import { http } from "Utils/http";
import { STATUSES } from "Utils/constants";

const getUserProfileInfo = async (ACTIONS, formInfoDispatch, handleInputTextChange, handleSelectChange, handleInputTelChange, listFuncs, token) => {

  formInfoDispatch({
    type: ACTIONS.SET_INITIAL_DATA,
    data: '',
    loading: true
  });

  const url = "/api/manage/getMyaccount";
  var status = STATUSES.SUCCESS;

  const res = await http.post(url, {}, {
    headers: {
      "Authorization": token
    }
  }).then((res) => {
    //console.log("print out getUserProfileInfo", res, res.data?.userInfo);

    const info = res.data?.userInfo;
    //const prefixList = res.data?.prefixList;
    const prefixList = listFuncs.prefixListValues(res.data?.prefixList, info?.prefix);
    const suffixList = listFuncs.suffixfixListValues(res.data?.suffixList, info?.suffix);
    const stateList = listFuncs.stateListValues(res.data?.demographics, info?.state);

    var data = {
      firstname: {
        value: info.firstname,
        validation: {
          required: true,
          isInvalid: false,
          errors: []
        },
        onChange: handleInputTextChange,
        disabled: false,
      },
      middlename: {
        value: info.middlename,
        validation: {
          required: false,
          isInvalid: false,
          errors: []
        },
        onChange: handleInputTextChange,
        disabled: false,
      },
      lastname: {
        value: info.lastname,
        validation: {
          required: true,
          isInvalid: false,
          errors: []
        },
        onChange: handleInputTextChange,
        disabled: false,
      },
      prefix: {
        value: info.prefix,
        options: prefixList,
        validation: {
          required: false,
          isInvalid: false,
          errors: []
        },
        onChange: handleSelectChange,
        disabled: false,
        readOnly: false,

      },
      suffix: {
        value: info.suffix,
        options: suffixList,
        validation: {
          required: false,
          isInvalid: false,
          errors: []
        },
        onChange: handleSelectChange,
        disabled: false,
        readOnly: false,

      },
      credentials: {
        value: info.credentials,
        validation: {
          required: false,
          isInvalid: false,
          errors: []
        },
        onChange: handleInputTextChange,
        disabled: false,
      },
      jobTitle: {
        value: info.jobTitle,
        validation: {
          required: false,
          isInvalid: false,
          errors: []
        },
        onChange: handleInputTextChange,
        disabled: false,
      },
      address1: {
        value: info.address1,
        validation: {
          required: true,
          isInvalid: false,
          errors: []
        },
        onChange: handleInputTextChange,
        disabled: true,
      },
      address2: {
        value: info.address2,
        validation: {
          required: false,
          isInvalid: false,
          errors: []
        },
        onChange: handleInputTextChange,
        disabled: true,
      },
      city: {
        value: info.city,
        validation: {
          required: true,
          isInvalid: false,
          errors: []
        },
        onChange: handleInputTextChange,
        disabled: true,
      },
      state: {
        value: info.state,
        options: stateList,
        validation: {
          required: true,
          isInvalid: false,
          errors: []
        },
        onChange: handleSelectChange,
        disabled: true,
        readOnly: false,

      },
      zip: {
        value: info.zip,
        validation: {
          required: true,
          isInvalid: false,
          errors: []
        },
        onChange: handleInputTextChange,
        disabled: true,
      },
      zipext: {
        value: info.zipext,
        validation: {
          required: false,
          isInvalid: false,
          errors: []
        },
        onChange: handleInputTextChange,
        disabled: true,
      },
      phone: {
        // phoneForDisplay: (xxx) xxx-xxxx
        value: info.phone,
        validation: {
          required: true,
          isInvalid: false,
          errors: []
        },
        onChange: handleInputTelChange,
        disabled: false,
      },
      phonextn: {
        value: info.phonextn,
        validation: {
          required: false,
          isInvalid: false,
          errors: []
        },
        onChange: handleInputTextChange,
        disabled: false,
      },
      fax: {
        // faxForDisplay: (xxx) xxx-xxxx
        value: info.fax,
        validation: {
          required: false,
          isInvalid: false,
          errors: []
        },
        onChange: handleInputTelChange,
        disabled: false,
      },
      emailaddress: {
        value: info.emailaddress,
        validation: {
          required: true,
          isInvalid: false,
          errors: []
        },
        onChange: handleInputTextChange,
        disabled: true,
      },
      editUserPassword: {
        value: "",
        validation: {
          required: true,
          isInvalid: false,
          errors: []
        },
        onChange: handleInputTextChange,
        disabled: false,
      }
    }

    formInfoDispatch({
      type: ACTIONS.SET_INITIAL_DATA,
      data: data,
      loading: false
    });

    return Promise.resolve({ status: status, data: res });

  }).catch(function (error) {
    //console.log("getUserProfileInfo()", error);
    status = STATUSES.ERROR;;
    return Promise.reject({ status: status, data: error });
  });

  return res;
}

const submitEditUserProfileData = async (userInfo, formInfo, nameConverter, addErrorMessages, clearErrorMessages, getFieldValue, token) => {

  clearErrorMessages(formInfo.data);

  //console.log("submitEditUserProfileData start", userInfo, formInfo.data, getFieldValue("phone", formInfo.data));
  //console.log("submitEditUserProfileData start2", getFieldValue("phone", formInfo.data));


  var body = {
    ...userInfo,
    firstname: getFieldValue("firstname", formInfo.data),
    middlename: getFieldValue("middlename", formInfo.data),
    lastname: getFieldValue("lastname", formInfo.data),
    prefix: getFieldValue("prefix", formInfo.data),
    suffix: getFieldValue("suffix", formInfo.data),
    credentials: getFieldValue("credentials", formInfo.data),
    jobTitle: getFieldValue("jobTitle", formInfo.data),
    phone: getFieldValue("phone", formInfo.data),
    phoneForDisplay: getFieldValue("phone", formInfo.data),
    phonextn: getFieldValue("phonextn", formInfo.data),
    fax: getFieldValue("fax", formInfo.data),
    editUserPassword: getFieldValue("editUserPassword", formInfo.data)
  }

  //console.log("submitEditUserProfileData request body", body);

  var url = '/api/manage/updateMyaccount';

  var status = STATUSES.SUCCESS;

  const res = await http.post(url, body, {
    headers: {
      "Authorization": token
    }
  }).then(res => {
    var x = 0;
    var isFirst = false;
    for (const [key, value] of Object.entries(nameConverter)) {
      //console.log(`Key: ${key}, Value: ${value}`);

      var d = res.fieldErrors;
      var values = d[key];

      if (values != null) {
        if (x == 0) {
          isFirst = true;
        }
        else {
          isFirst = false;
        }
        addErrorMessages(value, key, res, isFirst);
        status = STATUSES.ERROR;
        x = x + 1;
      }
    }

    return Promise.resolve({ status: status, data: res });

  }).catch(function (error) {
    //console.log("error caught from submitEditUserProfileData()", error);
    status = STATUSES.ERROR;;
    return Promise.reject({ status: status, data: error });
  });
  return res;
};

export { getUserProfileInfo, submitEditUserProfileData };